import { RichText } from "components/RichTextWidget";
import { Container, Heading3, LazyRenderingButton } from "shared/components";
import { LazyRenderingProvider } from "shared/components/LazyRenderingButton";

import styles from "./Content060.module.scss";
import { StudentsList } from "./StudentsList";

export const Content060 = ({ payload }) => {
  const title = payload?.title ?? "";
  const description = payload?.caption ?? "";
  const interviews = payload?.interviews ?? [];

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.block}>
          <div className={styles.top}>
            <Heading3 className={styles.title}>{title}</Heading3>
            <RichText
              color="grey"
              value={description}
              className={styles.description}
            />
          </div>
          <LazyRenderingProvider
            size={interviews.length}
            initialLimit={4}
            incrementBy={4}
          >
            <div className={styles.items}>
              <StudentsList students={interviews} />
            </div>
            <LazyRenderingButton />
          </LazyRenderingProvider>
        </div>
      </Container>
    </div>
  );
};

export default Content060;
